import ParameterErrors from '../errors/ParameterErrors';
import enableAcceptBindings from '../mvvm/enableAcceptBindings';
import exposeBinding from '../mvvm/exposeBinding';
import SiteJsonUnitBirdsEyeView from './SiteJsonUnitBirdsEyeView';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class SiteJsonUnitBirdsEyeViews{
	constructor(props){
		const {list}=props;
		this._list = list;
		this.getMarkerPositionForBirdsEyeViewWithIndex= this.getMarkerPositionForBirdsEyeViewWithIndex.bind(this);
		this.toJSON=this.toJSON.bind(this);
	}
	getMarkerPositionForBirdsEyeViewWithIndex(index){
		const birdsEyeViewsWithIndex = this._list.filter(birdsEyeView=>birdsEyeView.index===index);
		return birdsEyeViewsWithIndex.length>0?birdsEyeViewsWithIndex[0].markerPosition:null; 
	}
	toJSON(){
		throw new Error('Not implemented');
	}
	static fromJSON(jArray){
		const list = jArray.map(jObject=>SiteJsonUnitBirdsEyeView.fromJSON(jObject));
		return new SiteJsonUnitBirdsEyeViews({
			list:list
		});
	}
	
}